var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_89_1254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 0.922913H0V16.7203H24V0.922913H16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.923096H7.99983V16.7208H0V0.923096Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.923096H23.9998V16.7208H16V0.923096Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_89_1254"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 15.7975,
    fill: "white",
    transform: "translate(0 0.923096)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIt);
export default __webpack_public_path__ + "static/media/IT.4078f4df4654cf2582d94edcba5c520f.svg";
export { ForwardRef as ReactComponent };